import React, { useState } from "react";
import { MdCheckCircle } from "@react-icons/all-files/md/MdCheckCircle";
import { MdClose } from "@react-icons/all-files/md/MdClose";
import { useTranslation } from "react-i18next";
import { Dialog, IconButton, Typography, useTheme } from "@mui/material";
import Transition from "@shared/transitionSlideUp";
import { DialogBody } from "./finish.styles";

/**
 * Read-only screen for PENDING_REVIEW / ON_HOLD / PENDING_SAP_CODE (and unknown statuses).
 * Mirrors the finish dialog layout; no edit or submit affordances.
 *
 * Close (X) must NOT send the partner to "/" (OTP / re-entry). That route would let them
 * request OTP again and re-open /process. Instead: try window.close() for the WebView, and
 * fall back to a neutral dead-end copy on this same screen.
 */
function KycUnderReview() {
  const { t } = useTranslation();
  const theme = useTheme();
  const [dismissed, setDismissed] = useState(false);

  const handleClose = () => {
    try {
      window.close();
    } catch {
      // ignore — many embeds block window.close()
    }
    setDismissed(true);
  };

  return (
    <Dialog
      fullScreen
      open={true}
      TransitionComponent={Transition}
      data-testid="kyc-under-review"
    >
      {!dismissed && (
        <IconButton
          aria-label={t("close", { defaultValue: "Close" })}
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: theme.spacing(1),
            right: theme.spacing(1),
            zIndex: 1,
            color: theme.palette.secondary.main,
          }}
        >
          <MdClose size={28} />
        </IconButton>
      )}
      <DialogBody>
        <MdCheckCircle size={160} color={theme.palette.primary.main} />
        {dismissed ? (
          <>
            <Typography color="secondary" variant="h6">
              {t("kyc_close_window_title", {
                defaultValue: "You can close this window",
              })}
            </Typography>
            <Typography color="secondary">
              {t("kyc_close_window_body", {
                defaultValue:
                  "Your KYC is under review. No further action is needed right now.",
              })}
            </Typography>
          </>
        ) : (
          <>
            <Typography color="secondary" variant="h6">
              {t("kyc_under_review_title", { defaultValue: "KYC Under Review" })}
            </Typography>
            <Typography color="secondary">
              {t("kyc_under_review_body", {
                defaultValue:
                  "Your KYC documents are under review and cannot be edited at this time.",
              })}
            </Typography>
          </>
        )}
      </DialogBody>
    </Dialog>
  );
}

export default KycUnderReview;
